import { apiClient } from './apiClient';

export interface TVChannelImportItem {
  id: string;
  channelId?: string | null;
  selected: boolean;
  channelNumber?: number | null;
  title: string;
  countryId?: string | null;
  categories?: string[] | null;
  logoUrl?: string | null;
  url: string;
  imported?: boolean | null;
  error?: string | null;
}

export interface TVChannelNumberAvailability {
  channelNumber: number;
  taken: boolean;
  channelId?: string | null;
  title?: string | null;
}

export interface SavedTVChannelImport {
  id: string;
  name: string;
  sourceType: string;
  sourceValue?: string | null;
  importedCount: number;
  skippedCount: number;
  createdDate: string;
  items: TVChannelImportItem[];
}

export interface TVChannelImportResult {
  importedCount: number;
  skippedCount: number;
  items: TVChannelImportItem[];
  savedImport?: SavedTVChannelImport | null;
}

interface ParseResponse {
  success: boolean;
  channels: TVChannelImportItem[];
}

interface SavedImportsResponse {
  success: boolean;
  imports: SavedTVChannelImport[];
}

export interface ImportChannelsRequest {
  name?: string;
  sourceType: 'url' | 'file' | 'saved';
  sourceValue?: string;
  saveImport: boolean;
  items: TVChannelImportItem[];
}

export const tvChannelImportService = {
  async parseUrl(url: string): Promise<TVChannelImportItem[]> {
    const response = await apiClient.post<ParseResponse>('/tv-channels/imports/parse-url', { url });
    return response.channels;
  },

  async parseFile(file: File): Promise<TVChannelImportItem[]> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<ParseResponse>('/tv-channels/imports/parse-file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.channels;
  },

  async checkChannelNumber(channelNumber: number, excludeChannelId?: string | null): Promise<TVChannelNumberAvailability> {
    return apiClient.get<TVChannelNumberAvailability>(
      `/tv-channels/imports/channel-number/${channelNumber}/availability`,
      excludeChannelId ? { excludeChannelId } : undefined
    );
  },

  async importChannels(request: ImportChannelsRequest): Promise<TVChannelImportResult> {
    return apiClient.post<TVChannelImportResult>('/tv-channels/imports', request);
  },

  async getSavedImports(): Promise<SavedTVChannelImport[]> {
    const response = await apiClient.get<SavedImportsResponse>('/tv-channels/imports');
    return response.imports;
  },
};
